export default {
  methods: {
    stringRule(prop, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur', 'change'],
        },
      ];
    },
    numberRule(prop, min, max, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          type: 'number',
          message: `Please input valid ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          validator: (rule, value, callback) => {
            if (_.isInteger(value)) {
              if (_.isInteger(min) && _.isInteger(max)) {
                if (value < min || value > max)
                  callback(
                    new Error(`${_.upperFirst(name)} must be ${min} ~ ${max}`)
                  );
              } else if (_.isInteger(min)) {
                if (value < min)
                  callback(
                    new Error(`${_.upperFirst(name)} must be >= ${min}`)
                  );
              } else if (_.isInteger(max)) {
                if (value > max)
                  callback(
                    new Error(`${_.upperFirst(name)} must be <= ${max}`)
                  );
              } else {
                if (value <= 0)
                  callback(new Error(`${_.upperFirst(name)} must be > 0`));
              }
            }
            callback();
          },
          trigger: ['blur', 'change'],
        },
      ];
    },
    facebookLivestreamSizeRule(prop) {
      return [
        {
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            if (value < 220) {
              callback(new Error(`facebook livestream must >= 220`));
            }
            callback();
          },
        },
      ];
    },
    sizeRule(prop, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          pattern: /^\d+x\d+$/,
          message: `The size is width by height ( Width x Height )`,
          trigger: ['blur', 'change'],
        },
        {
          validator: (rule, value, callback) => {
            if (value.some((v) => v <= 0))
              callback(new Error(`Width and height must be > 0`));
            else callback();
          },
          trigger: ['blur', 'change'],
          transform(value) {
            return value.split('x').map((v) => Number(v));
          },
        },
      ];
    },
    imageSizeRule({ ...size }) {
      let width_min = size.width.min;
      let width_max = size.width.max;
      let height_min = size.height.min;
      let height_max = size.height.max;
      return [
        {
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            let img = new Image();
            if (!value) {
              callback();
            }
            img.onload = function() {
              if (
                this.width > width_max ||
                this.width < width_min ||
                this.height > height_max ||
                this.height < height_min
              ) {
                return callback(new Error('please choose correct size image'));
              } else {
                callback();
              }
            };
            img.src = value;
          },
        },
      ];
    },
    bannerImageRatioRule({ ...size }) {
      let sizeWidth = size.width.min;
      let sizeHeight = size.height.min;
      return [
        {
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            let img = new Image();
            if (!value) {
              callback();
            }
            img.onload = function() {
              let widthRatio = this.width / sizeWidth;
              let heightRatio = this.height / sizeHeight;
              if (widthRatio !== heightRatio) {
                return callback(new Error('please choose correct ratio image'));
              } else {
                callback();
              }
            };
            img.src = value;
          },
        },
      ];
    },
    imageRatioRule({ ...size }) {
      let sizeWidth = size.width;
      let sizeHeight = size.height;
      return [
        {
          trigger: ['change', 'blur'],
          validator: (rule, value, callback) => {
            let img = new Image();
            if (!value) {
              callback();
            }
            img.onload = function() {
              let widthRatio = this.width / sizeWidth;
              let heightRatio = this.height / sizeHeight;
              if (widthRatio !== heightRatio) {
                return callback(new Error('please choose correct ratio image'));
              } else {
                callback();
              }
            };
            img.src = value;
          },
        },
      ];
    },
    urlRule(prop, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          max: 2048,
          message: `The length must be <= 2048 characters`,
          trigger: ['blur', 'change'],
        },
        {
          validator: (rule, value, callback) => {
            if (value.trim() === value) callback();
            callback(
              new Error(
                `The url doesn't allow whitespace at the beginning and end`
              )
            );
          },
          trigger: ['blur', 'change'],
        },
        {
          type: 'url',
          message: `Please input valid ${name}`,
          trigger: ['blur', 'change'],
        },
      ];
    },
    optionRule(prop, options = [], required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please select ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          type: 'enum',
          enum: options.map((opt) => opt.value),
          message: `Please select valid ${name}`,
          trigger: ['blur', 'change'],
        },
      ];
    },
    repeatPasswordRule(prop, data, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur', 'change'],
        },
        {
          validator: (rule, value, callback) => {
            if (value === data) callback();
            callback(new Error(`must be the same with ${name}`));
          },
          trigger: ['blur'],
        },
      ];
    },
    passwordRule(prop, required = true) {
      const name = _.lowerCase(prop);
      return [
        {
          required,
          message: `Please input ${name}`,
          trigger: ['blur'],
        },
        {
          validator: (rule, value, callback) => {
            let strArr = value.split('');
            let hasLowerCase = false;
            let hasUpperCase = false;
            let hasDigit = false;
            let biggerThanEight = strArr.length >= 8 ? true : false;
            strArr.forEach((word, index) => {
              if (word >= 'a' && word <= 'z') {
                hasLowerCase = true;
              } else if (word >= 'A' && word <= 'Z') {
                hasUpperCase = true;
              } else if (word >= '0' && word <= '9') {
                hasDigit = true;
              }
            });
            if (hasLowerCase && hasUpperCase && hasDigit && biggerThanEight) {
              callback();
            } else {
              callback(
                new Error(
                  `at least 8 words with 1 upper case, 1 lower case, 1 digit.  `
                )
              );
            }
          },
          trigger: ['blur'],
        },
      ];
    },
  },
};
